import { createReducer } from '@reduxjs/toolkit';
import { SET_PROGRAMS_DATA } from '../actions/ProgramsAction';

const initialState = {
    programsData: [],
};

const programs = createReducer(initialState, (builder) => {
    builder
        .addCase(SET_PROGRAMS_DATA, (state, action) => {
            state.programsData = action.programsData;
        });
});

export default programs;
